import {
  clearFlagsFromFlagsManager,
  maybeDispatchContentIdChanged,
  rebuildFieldTypesConfig,
} from '@databases/core-event-bus/listeners';
import { rebuildFieldTypesConfig as rebuildFieldsConfig } from '@databases/fields';
import { container } from '@databases/service-container';

/**
 * Register core event listeners. This should be invoked early on in the bootstrapping of the application.
 */
function registerCoreEventListeners() {
  const eventBus = container.resolve('EventBus');

  eventBus.on('bridgeDataChanged', maybeDispatchContentIdChanged(eventBus));
  eventBus.on('databaseContentIdChanged', () => {
    clearFlagsFromFlagsManager(container.resolve('FlagsManager'));
  });
  eventBus.on('featureFlagsChanged', rebuildFieldTypesConfig(rebuildFieldsConfig));
}

export { registerCoreEventListeners };
